import { setFiledToPersonalDetailsLocalStorage } from "../commonfunctions/helper"

export const changeName = (val) => {
    setFiledToPersonalDetailsLocalStorage('name',val)
    return {
        type: "CHANGE_PERSONAL_DETAIL_NAME",
        value: val
    }
}
export const changeMobile = (val) => {
    setFiledToPersonalDetailsLocalStorage('mobile',val)
    return {
        type: "CHANGE_PERSONAL_DETAIL_MOBILE",
        value: val
    }
}
export const changeEmail = (val) => {
    setFiledToPersonalDetailsLocalStorage('email',val)
    return {
        type: "CHANGE_PERSONAL_DETAIL_EMAIL",
        value: val
    }
}
export const changeAge = (val) => {
    setFiledToPersonalDetailsLocalStorage('age',val)
    return {
        type: "CHANGE_PERSONAL_DETAIL_AGE",
        value: val
    }
}
export const changeGender = (val) => {
    setFiledToPersonalDetailsLocalStorage('gender',val)
    return {
        type: "CHANGE_PERSONAL_DETAIL_GENDER",
        value: val
    }
}